import React from "react";
import ProgressIndicatorBullets from "./components/ProgressIndicatorBullets";
import {
  getAllOxygenMappings,
  getCurrentPreviewIssueAttributes,
  getCurrentUser,
  getCurrentViewType,
} from "../../../../redux/selectors";
import { connect } from "../../../../redux/connect";
import { getCallToActionOptions, getStatusFromServerStatus } from "../../../../utils/transition-helpers";
import { issueAttributesType, oxygenType } from "../../../../constants/proptype-validation";
import PropTypes from "prop-types";
import { ButtonGroup, UserAvatar, DEFAULT_AVATAR, Text } from "@adsk/bim360-matrix-react-components";
import {
  STATUS_ANSWERED,
  STATUS_CLOSED,
  STATUS_DRAFT,
  STATUS_OPEN,
  STATUS_REJECTED, STATUS_SUBMITTED, STATUS_VOID,
} from "../../../../constants/status-types";
import classNames from 'classnames';
import T from "i18n-react";
import lodashGet from 'lodash/get';
import { viewTypes } from "../../../../constants/view-types";

const StatusStepMapper = {
  [STATUS_DRAFT]: { number: 0, key: 'statusText.draft' },
  [STATUS_SUBMITTED]: { number: 0, key: 'statusText.submitted' },
  [STATUS_OPEN]: { number: 1, key: 'statusText.open' },
  [STATUS_ANSWERED]: { number: 2, key: 'statusText.answered' },
  [STATUS_REJECTED]: { number: 2, key: 'statusText.rejected' },
  [STATUS_CLOSED]: { number: 3, key: 'statusText.closed' },
};

const StatusIndicatorBar = ({ issue, onStatusChange, currentUser, oxygen, viewType }) => {

  const fallbackUser = {
    name: T.translate('activity_v2.formerUser'),
    profileImg50: DEFAULT_AVATAR,
  };
  const isCurrentUserAssignee = lodashGet(currentUser, 'attributes.id') === issue.assignedTo;
  const assignedToUser = oxygen.users[issue.assignedTo] || fallbackUser;
  const assignee = issue.currentAssignee || assignedToUser.name;
  const status = getStatusFromServerStatus(issue.status);
  const isCompleted = status === STATUS_CLOSED;
  const shouldShowProgress = status !== STATUS_DRAFT && status !== STATUS_VOID;
  const isDocumentView = viewType === viewTypes.DOCUMENT;
  const keyPostfix = isCurrentUserAssignee && status !== STATUS_CLOSED && status !== STATUS_DRAFT ? 'ForYou' : '';

  const handleActionSelect = (actionId, action) => {
    onStatusChange(action);
  };

  const renderCallToActionOptions = () => {
    const options = getCallToActionOptions(issue);

    if (!options.length) {
      return null;
    }
    return <ButtonGroup
      options={options}
      onSelect={handleActionSelect}
      isSaving={false}
      savingText={options[0].label}
    />;
  };

  if (status === STATUS_VOID) {
    return null;
  }

  return <div className={classNames("StatusIndicatorBar", { "StatusIndicatorBar--narrow": isDocumentView }, { "StatusIndicatorBar--wide": !isDocumentView })}>
    <div className={classNames("StatusIndicatorBar__content", { "StatusIndicatorBar__content--completed": isCompleted }, { "StatusIndicatorBar__content--narrow": isDocumentView }, { "StatusIndicatorBar__content--wide": !isDocumentView })}>
      <div className="StatusIndicatorBar__row">
        <div className="StatusIndicatorBar__title">{T.translate(`statusTitle.${status}`)}</div>
        {shouldShowProgress && <ProgressIndicatorBullets bulletNumber={3} completed={StatusStepMapper[status].number} isSmall={isDocumentView} />}
      </div>
      <div className="StatusIndicatorBar__row StatusIndicatorBar__action-row">
        <div className="StatusIndicatorBar__action">
          {!isCompleted && <UserAvatar user={assignedToUser} className="StatusIndicatorBar__user-avatar" />}
          <Text hasHTML className="StatusIndicatorBar__text">{T.translate(`${StatusStepMapper[status].key}${keyPostfix}`, { assignee })}</Text>
        </div>
        {renderCallToActionOptions()}
      </div>
    </div>
  </div>;
};


StatusIndicatorBar.displayName = 'StatusIndicatorBar';

StatusIndicatorBar.propTypes = {
  issue: issueAttributesType,
  onStatusChange: PropTypes.func.isRequired,
  viewType: PropTypes.string.isRequired,
  oxygen: oxygenType.isRequired,
  currentUser: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  issue: getCurrentPreviewIssueAttributes(state),
  viewType: getCurrentViewType(state),
  currentUser: getCurrentUser(state),
  oxygen: getAllOxygenMappings(state),
});

export default connect(mapStateToProps)(StatusIndicatorBar);
